import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Divider, Input, Select} from "antd";

const {Option} = Select;

function mapStateToProps(state) {
    return {};
}

let index = 0;

class SelectAddNew extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: ['Baseline Average', 'Post-Period Average', 'Custom'],
            name: props.price ?? null,
        }
    }

    componentDidUpdate(prevProps) {
        // 当 props 发生变化时更新 name
        const priceChanged = prevProps.price !== this.props.price;
        const valueChangedToCustom = prevProps.value !== this.props.value && this.props.value === 'Custom';
        
        if (priceChanged || valueChangedToCustom) {
            this.setState({
                name: this.props.price ?? null,
            });
        }
    }

    onNameChange = event => {
        this.setState({
            name: event.target.value,
        });
        this.props.onSelect('Custom', event.target.value)
    };

    handleChange = (value) => {
        // 切换到 Custom 时，如果有 price prop，使用它
        if (value === 'Custom' && this.props.price) {
            this.setState({ name: this.props.price });
            this.props.onSelect(value, this.props.price);
        } else {
            this.props.onSelect(value, null);
        }
    }

    render() {
        const {items, name} = this.state;
        return (
            <div className={'flex'}>
                <Select
                    onChange={this.handleChange}
                    placeholder={this.props.placeholder}
                    defaultValue={this.props.default}
                    value={this.props.value}
                    dropdownRender={menu => (
                        <div>
                            {menu}

                        </div>
                    )}
                >
                    {items.map(item => (
                        <Option key={item}>{item}</Option>
                    ))}
                </Select>

                {this.props.value === 'Custom' ? (
                    <Input prefix={'$ '} style={{width:'80px'}} value={name} onChange={this.onNameChange}/>
                ) : (
                    <Input 
                        prefix={'$ '} 
                        style={{width:'80px'}} 
                        value={this.props.calculatedPrice?.toFixed(3)} 
                        disabled 
                    />
                )}
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
)(SelectAddNew);
